import {rtkApi} from '../apiSlice';
import {rtkActionHandler} from '../rtkHandler';
import {
    getActiveCycles,
    getSiteSettingsForUsers,
    processStudentRegistration,
    verifyDOBIfEligible
} from "@/redux/apis/students/shared";
import {DOB_VERIFICATION} from "@/redux/rtk/students/types";
import {USER_REGISTRATION} from "@/components/admin/login/types";

const apiWithPortalAdministrationTag = rtkApi.enhanceEndpoints?.({ addTagTypes: [] });

export const sharedApi = apiWithPortalAdministrationTag.injectEndpoints({
    endpoints: (builder) => ({
        getActiveCycles: builder.query<any, null>({
            queryFn: async () => {
                return rtkActionHandler(getActiveCycles());
            },
        }),
        verifyDOBIfEligible: builder.mutation<any, DOB_VERIFICATION>({
            queryFn: async (data: DOB_VERIFICATION) => {
                return rtkActionHandler(verifyDOBIfEligible(data));
            },
        }),
        processStudentRegistration: builder.mutation<any, USER_REGISTRATION>({
            queryFn: async (data: USER_REGISTRATION) => {
                return rtkActionHandler(processStudentRegistration(data));
            },
        }),
        getSiteSettingsForUsers: builder.query<any, number>({
            queryFn: async (dataType: number) => {
                return rtkActionHandler(getSiteSettingsForUsers(dataType));
            }
        }),
    })
});

export const {
    useGetActiveCyclesQuery,
    useVerifyDOBIfEligibleMutation,
    useProcessStudentRegistrationMutation,
    useGetSiteSettingsForUsersQuery
} = sharedApi;